import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Report period modal opened from the main menu.
@Component({
  selector: 'report-period-modal',
  templateUrl: './report-period-modal.component.html',
})
export class ReportPeriodModalComponent {
  @Input() formFrom: FormGroup;
  @Input() formTo: FormGroup;
  @Input() title: string = '';
  @Input() reportId: any;

  @Output() confirmed = new EventEmitter<any>();
}
